<template>
    <div id="sessionCardBody">
      <!--
        - On envoie une liste de mots à vocabulary-card
        - On envoie l'info du chargement de cette liste
      -->
      <vocabulary-card v-if="appStep===states.ONGOING_SESSION"
                       :vocab="vocab"
                       :vocabLoaded="vocabLoaded">
      </vocabulary-card>

      <pendu v-if="appStep===states.ONGOING_GAME"
             :words-list="gameWordsList.vocab"
             :wordsLoaded="gameWordsList.loaded">
      </pendu>

      <questions v-if="appStep===states.ONGOING_QUESTIONS"
                 :episode-id="currentEpisodeData.id"
      >
      </questions>
    </div>

</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import {API_URL} from '../App'
import axios from "axios";
import {lock} from '../main'

export default {
  name: "sessionCard",
  components: {
    VocabularyCard: () => import(/* webpackPrefetch: true */ '@/components/vocabularyCard.vue'),
    pendu: () => import(/* webpackPrefetch: true */ '@/components/pendu.vue'),
    questions: () => import(/* webpackPrefetch: true */ '@/components/questions.vue')
  },

  created() {
    if (this.authenticated) {
      /*if (this.appStep !== this.states.ONGOING_SESSION) {
        this.set_appStep(this.states.ONGOING_SESSION)
      }*/
      this.add_currentEpisodeData({name: 'vocabLoaded', value: false});
      // on regarde quels types de mots doivent être chargés
      let type = ''
      if(this.appStep === this.states.ONGOING_SESSION) {
        this.fetchSessionLemmas();
      }
      else if(this.appStep === this.states.ONGOING_GAME) {
        this.fetchGameLemmas();
      }
      this.set_startDate(new Date().toISOString());
      this.reset_learntLemmasId();
      this.reset_learntWords();
      this.set_errorsNumber(0)
    }

  },
  beforeDestroy() {
    this.$session.clear();
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'appStep',
      'states',
      'routeParams',
      'authenticated'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
    ]),
    ...mapGetters('session', [
      'sessionWordsList',
      'sessionType',
    ]),
    ...mapGetters('game', [
      'gameOn',
      'gameWordsList',
      'gameOrigin'
    ]),

    vocab: function () {
      return this.sessionWordsList.vocab
     /* if (this.sessionType === 'episode') {
        return this.sessionWordsList.vocab
      } else if (this.sessionType === 'season') {
        // On transforme la liste pour donner aux éléments le même format que currentEpisodeData.vocab[i]
        /*this.sessionWordsList.vocab.forEach((element) =>  {
          let sentence = {
            sentence: element.definition}
          element['first_sentence'] =  sentence;
          element['lemma'] = {
            separateTrads: element.separateTrads,
            english: element.english,
            decenglish: element.decenglish,
            id: element.id,
            user_lemma: element.user_lemma
          }
        })
        if(this.$isDebug) {
          return this.sessionWordsList.vocab.slice(0,5)
        }
        return this.sessionWordsList.vocab.slice(0,10)
      } else {
        return []
      }*/
    },

    vocabLoaded: function () {
        return this.sessionWordsList.loaded
    }
  },

  watch: {
    vocabLoaded: function(){
      // Si on ne récupère pas plus de 4 mots, on retourne sur episodeCard
      if(this.vocab.length <5) {
        this.set_appStep(this.states.MENU)
      }
    }
  },

  methods: {
    ...mapActions('global', [
      'set_appStep',
    ]),
    ...mapActions('show', [
      'set_currentEpisodeData',
      'set_currentShowLoaded',
      'add_currentEpisodeData'
    ]),
    ...mapActions('session', [
      'set_startDate',
      'set_sessionWordsListLoaded',
      'set_sessionWordsList',
      'reset_learntWords',
      'reset_learntLemmasId',
      'set_errorsNumber'
    ]),
    ...mapActions('game', [
      'set_gameWordsList',
      'set_gameWordsListLoaded'
    ]),

    fetchSessionLemmas() {
      let token = "";
      const url = `${API_URL}/api/episode/` + this.currentEpisodeData.id + '/'
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          token = authResult.accessToken;

          axios.get(url, {headers: {Authorization: `Bearer ${token}`}})
              //this.$http.get('http://localhost:8000/api/episode/' + episode.id + '/')
              .then(response => {
                return response.data;
              })
              .then(data => {
                    let epData1 = {
                      name: 'vocab',
                      value: this.order(data.best_words)
                    };
                    let epData2 = {
                      name: 'vocabLoaded',
                      value: true
                    };

                    if(this.sessionType === 'episode') {
                      this.set_sessionWordsList(epData1.value);
                      this.set_sessionWordsListLoaded(true)
                    }
                    this.add_currentEpisodeData(epData1);
                    this.add_currentEpisodeData(epData2);

                  }
              );
        }
        else {
          console.log(error)
        }
      });
    },

    fetchGameLemmas() {
      this.set_gameWordsListLoaded(false)
      let token = "";
      const url = `${API_URL}/api/episode_vocabulary/` + this.currentEpisodeData.id + '/'
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          token = authResult.accessToken;

          axios.get(url, {headers: {Authorization: `Bearer ${token}`}})
              //this.$http.get('http://localhost:8000/api/episode/' + episode.id + '/')
              .then(response => {
                return response.data;
              })
              .then(data => {
                    this.set_gameWordsList(data);
                    this.set_gameWordsListLoaded(true)
                  }
              );
        }
        else {
          console.log(error)
        }
      });
    },

    order: function (list) {
      let tempList = list.slice();
      for (let i = 0; i < tempList.length; i++) {
        if (tempList[i].lemma.is_vulgar && this.$cookies.get('forKids') == 1) {
          tempList.splice(i, 1);
        }
        tempList[i].count = 2;
      }

      return tempList;
    },
  },

  data: function () {
    return {
      //duration: 3,
    }
  }
}
</script>

<style scoped>
#sessionCardBody {
  /*height: 100%;*/
  display: flex;
  flex-grow: 1;
}

.login {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}

.startbutton {
  grid-column: 4/5;
  height: 100%;
  width: 100%;
  display: grid;
  align-self: center;
  justify-self: center;
  align-content: center;
  align-items: center;
  justify-content: center;
  font-size: 2.2vw;
  cursor: pointer;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}

.netflixLogo {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  grid-column: 3/5;
  text-decoration: none;
}

/*.bgposter {
    height: calc(100% - 12vw);
    width: 100%;
    position: absolute;
    z-index: -1;
    filter: blur(10px);
    -webkit-filter: blur(10px);
}

.netflixLogo img {
    width: 1.5vw;
    padding: 0.75vw
}*/
</style>